import { style } from '@vanilla-extract/css';
import { nToPx, themeVars } from '@tundr/theme';

export const checkboxGroupClass = style({
  display: 'flex',
  flexDirection: 'column',
  gap: themeVars.space.x4,
});

export const checkboxGroupItemsClass = style({
  display: 'grid',
  gridTemplateColumns: 'repeat(2, 1fr)',
  alignItems: 'center',
  gap: nToPx(themeVars.space.x4, themeVars.space.x10),
});
